module.exports = __webpack_public_path__ + "img/svg/add-round.e51bfc2bd33761b2d4f5e9f21509e776.svg";